module.exports = __webpack_public_path__ + "static/media/twitter.ba057a21.svg";